"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import useRouter from "@/hooks/useRouter";
import { Input, Switch, Toast } from "antd-mobile";
import { replaceParams,replaceParamsStore } from "@/utils/utils";
import s from "./SearchDom.module.css";
import fangdajing02 from "@/images/fangdajing02.png";
import backimg from "@/images/back.png";

const Page = (props) => {
  const {
    getData,
    cityData,
    selectedCityFun,
    setIsOnFocus,
    isOnFocus,
    urlParams,
    book
  } = props;
  const effluentStandard = urlParams?.effluentStandard;
  let returnPath = decodeURIComponent(urlParams?.returnPath); // 回调url
  const callBackField = urlParams?.callBackField; // 排放标准

  const [value, setValue] = useState(); // 查询条件
  const [checked, setChecked] = useState(!!effluentStandard);
  const router = useRouter();

  useEffect(()=>{
    setChecked(!!effluentStandard)
  },[effluentStandard])

  const gotoNew = () => {
    // 购车方案页面
    if (urlParams.storeId) {
      returnPath = returnPath.replace("/storeId", `/${urlParams.storeId}`);
    }

    let pam ='';
    if(urlParams.fromStore){
      pam = replaceParamsStore(
        null,
        {},
        urlParams,
        "callBackField,returnPath,dels"
      );
    }else{
      pam = replaceParams(
        urlParams,
        callBackField,
        urlParams,
        "callBackField,returnPath,dels"
      );
    }

    router.replace(`${returnPath}${pam}`);
  };

  const switchFun = (e) => {
    if (effluentStandard) {
      Toast.show({
        content: (
          <div className={s.toast}>
            <div>为保证服务质量，暂仅对淘</div>
            <div>车车门店城市提供提车服务</div>
          </div>
        )
      });
      return;
    } else {
      setChecked(e);
    }
    book.reComputed({ isToTop: 1 });
    getData(e ? 1 : 0);
  };

  const searchDom = () => {
    return (
      <div className={s.search03}>
        {isOnFocus ? null : (
          <Image
            src={backimg}
            alt=""
            className={s.backimg}
            onClick={() => {
              gotoNew();
            }}
          ></Image>
        )}
        <div className={s.search04}>
          <div className={s.fangdajing}>
            <Image
              src={fangdajing02}
              alt=""
              className={s.fangdajingImage}
            ></Image>
          </div>
          <Input
            placeholder="请输入城市名称查询"
            value={value}
            clearable
            className={s.search03text}
            onFocus={() => setIsOnFocus(true)}
            onChange={setValue}
          />
        </div>
        {isOnFocus ? (
          <div
            className={s.quxiao}
            onClick={() => {
              setValue("");
              setIsOnFocus(false);
            }}
          >
            取消
          </div>
        ) : null}
      </div>
    );
  };

  const renderSearchDom = () => {
    if (!value) return null;

    return (
      <div className={s.search}>
        {cityData.map((item, idx) => {
          if (item.groupName === "HOT") return;

          {
            return item.cityList.map((item2, idx2) => {
              if (item2.cityName.indexOf(value) > -1) {
                const reg = new RegExp(`(${value}+)`, "g");

                return (
                  <div
                    key={`searchcity2${idx2}`}
                    className={s.search2}
                    onClick={() => {
                      selectedCityFun(item2);
                    }}
                    dangerouslySetInnerHTML={{
                      __html: item2.cityName.replace(
                        reg,
                        '<span style="color:var(--primary);">$1</span>'
                      )
                    }}
                  ></div>
                );
              }
            });
          }
        })}
      </div>
    );
  };

  return (
    <div className={s.search02}>
      {searchDom()}
      {isOnFocus ? (
        renderSearchDom()
      ) : (
        <div className={s.titdiv}>
          <div className={s.tit}>淘车车门店城市</div>
          <Switch
            className={s.switch}
            checked={checked}
            onChange={(e) => {
              switchFun(e);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default Page;
